import Image from "next/image";

import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import { CMSImage } from "common/blocks/Image/cms-image";
import RichText from "common/blocks/RichText";
import { ResolvedStaticCard } from "resolvers/data/staticCardResolver";
import { checkRichTextIsNotEmpty } from "utils/checkRichTextIsNotEmpty";

import styles from "./StaticCard.module.scss";

const cx = classNames.bind(styles);

const StaticCard = (props: ResolvedStaticCard) => {
    const { isInComponentWrapper, parentHasHeading } = props;

    const extension = props.image?.src.split(".");
    const isSVG = extension && extension[extension.length - 1] === "svg";

    return (
        <div className={cx("staticCardContainer")}>
            {props.heading &&
                props.headingLocation === "above_image" &&
                (!parentHasHeading || isInComponentWrapper ? (
                    <h2 className={cx("heading", "above")}>{props.heading}</h2>
                ) : (
                    <h3 className={cx("heading", "above")}>{props.heading}</h3>
                ))}
            {!!props.image && (
                <div className={cx("imageWrapper", { isInComponentWrapper })}>
                    {isSVG ? (
                        <Image
                            className={cx(`${props.imageType}`)}
                            {...props.image}
                            alt={props.image.alt}
                            height={0}
                            width={0}
                            sizes="(max-width: 1023px) 100vw, (min-width: 1024px) 33vw"
                        />
                    ) : (
                        <CMSImage
                            className={cx(`${props.imageType}`)}
                            {...props.image}
                            quality={80}
                            sizes="(max-width: 1023px) 100vw, (min-width: 1024px) 33vw"
                        />
                    )}
                </div>
            )}
            {props.heading &&
                props.headingLocation === "below_image" &&
                (!parentHasHeading || isInComponentWrapper ? (
                    <h2 className={cx("heading")}>{props.heading}</h2>
                ) : (
                    <h3 className={cx("heading")}>{props.heading}</h3>
                ))}
            {!!props.copy && checkRichTextIsNotEmpty(props.copy?.html) && (
                <RichText className={cx("copy")} {...props.copy} />
            )}
            {!!props.cta && (
                <div>
                    <Button
                        className={cx("ctaButton", { isInComponentWrapper })}
                        href={props.cta.link}
                        theme={props.cta.priority}
                        target={props.cta.target}
                        autoWidth
                    >
                        {props.cta.text}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default StaticCard;
